export default "__VITE_ASSET__kjLZ5ZH6__"